<template>
    <div class="mainWrapper" id="mainWrapper">
        <DisplaySection class="section" 
                        text-display="left"
                        v-waypoint="{ active: activateWaypoint, callback: emitBio, options: intersectionOptions}">
            <div class="bioWrapper">
                <p>
                    I am a software engineer with a wide variety for skills, for hire and consultation.
                    My passion for new technologies is matched only by my enthusiasm to develop new products with them.
                    Some of the various interests I rarely have time for include constantly fixing my 3d Printer, solving
                    Rubix&reg; cubes for the amusement of small children, and arguing with strangers online over the
                    benefits of tabs vs spaces. I have recently picked up hardware and circuit development as well, because
                    why not?
                </p>
                <p>
                    When I do get free time, I usually work on small web apps, IoT devices, or tutorials in whichever
                    flavor of JS happens to come out that week.
                </p>
                <p>
                    If you like what you see, feel free to peruse my professional history in my
                    <a :href="resumeLink" target="_blank" rel="noopener">resume</a> at your
                    convenience. If you REALLY like what you see, feel free to contact me.
                </p>
            </div>
        </DisplaySection>

        <DisplaySection class="section" 
                        text-display="right">
            <timeline :skills="skills"></timeline>
        </DisplaySection>

        <DisplaySection class="section" 
                        text-display="full" 
                        v-waypoint="{ active: activateWaypoint, callback: emitGallery, options: intersectionOptions}">
            <ImageGallery/>
        </DisplaySection>

    </div>
</template>

<script>
    import DisplaySection from "./DisplaySection";
    import Timeline from "./Timeline";
    import ImageGallery from "./ImageGallery";

    export default {
        name: "MainLayout",
        components: {DisplaySection, Timeline, ImageGallery},
        data : function(){
            return {
                activateWaypoint : true,
                resumeLink : process.env.VUE_APP_BASE_URL+'/RESUME.pdf',
                intersectionOptions: {
                    root: null,
                    rootMargin: '0px',
                    threshold: [0.90]
                },
				skills:[
                    /**
                    1 I've played around with it before
                    2 I've used it in school
                    3 I've used it in my side projects
                    4 I've used this at work
                    + personal confidence (1-10)

                    (java = 1 + 2 + 3 + 4 = 10)
                    **/
                    {
                        type: "/languages",
                        icon: "",
                        data:[
                            {name:"Java",   comfort:[4,3,2,1],personal:7},
                            {name:"Python", comfort:[4,3,2,1],personal:7},
                            {name:"JS",     comfort:[4,3,2,1],personal:8},
                            {name:"S/CSS",  comfort:[4,3,2,1],personal:6}
                        ]
                    },
                    {
                        type: "/frameworks",
                        icon:"",
                        data:[
                            {name:"Flask",      comfort:[4,3,2,1],  personal:7},
                            {name:"DropWizard", comfort:[4,3,1],      personal:4},
                            {name:"NodeJS",     comfort:[4,3,2,1],  personal:7},
                            {name:"jQuery",     comfort:[4,3,2,1],  personal:7},
                            {name:"AngularJS",  comfort:[4,1],      personal:7},
                            {name:"VueJS",      comfort:[4,3,1],    personal:4},
                            {name:"MongoDB",    comfort:[4,1],      personal:5},
                            {name:"SQL",        comfort:[4,2,1],    personal:5}
                        ]
                    },
                    {
                        type: "/software",
                        icon: "",
                        data:[
                            {name:"Git",        comfort:[4,3,2,1],  personal:7},
                            {name:"RabbitMQ",   comfort:[4,1],      personal:6},
                            {name:"Jenkins",    comfort:[4,3,2,1],  personal:6},
                            {name:"SonarQube",  comfort:[4,3,2,1],  personal:6},
                            {name:"Photoshop",  comfort:[3,2,1],    personal:7}
                        ]
                    },
                    {
                        type: "/platforms",
                        icon: "",
                        data:[
                            {name:"Linux",      comfort:[4,3,2,1],  personal:7},
                            {name:"Windows",    comfort:[4,3,2,1],  personal:8},
                            {name:"Heroku",     comfort:[3,2,1],    personal:6},
                            {name:"AWS",        comfort:[4,1],      personal:6},
                            {name:"Docker",     comfort:[4,3,1],    personal:6},
                            {name:"Nginx",      comfort:[4,3,1],    personal:6},
                        ]
                    },
                    {
                        type: "/hardware",
                        icon: "",
                        data:[
                            {name:"Raspberry Pi",     comfort:[4,3,2,1],personal:8},
                            {name:"3d Printers",      comfort:[4,3,2,1],personal:8},
                            {name:"Arduino",          comfort:[3,2,1],  personal:8}
                        ]
                    }
                ]
            }
        },
        created(){
            //Check if dimensions are above tablet
            this.checkDimension();
        },
        methods : {
            checkDimension: function(){
                this.activateWaypoint = (window.innerWidth>768);
            },
            emitBio : function( {going, direction} ){
                if(going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP){
                    // Coming in from top of page
                    // Plays canvas and pauses background
                    this.$root.$emit('bioEnter');
                }
                else if(going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_BOTTOM){
                    // Exiting from bottom
                    // Clears canvas and replays background
                    this.$root.$emit('exit');
                }
            },
            emitGallery : function( {going, direction} ){
                if(going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_BOTTOM){
                    // Scrolling up to skill
                    // Replays canvas and pauses background
                    this.$root.$emit('skillEnter');
                }
                else if(going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP){
                    // Hide canvas's, dont animate backgroun yet
                    this.$root.$emit('skillExit');
                }
                else if(going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_TOP){
                    // Scrolling down to contact
                    // Replays background
                    this.$root.$emit('exit');
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/scss/_variables.scss';
    @import '../assets/scss/_sectionWrappers.scss';
    .mainWrapper{
        grid-row: 2/3;
    }

    .section{
        min-height:100vh;
    }

    @media screen and (max-width:$tabletWidth){
        .section{
            max-height: 80vh;
            min-height: 60vh;
        }
    }

    @media screen and (max-width:$largeMobile){
        .section{
            max-height: 95vh;
            min-height: 60vh;
        }
    }
</style>
